(() => {
  const initialiseProductPanel = (root = document) => {
    root.querySelectorAll('[data-karigari-product-panel]').forEach((panel) => {
      if (panel.dataset.karigariProductReady === 'true') return;

      const select = panel.querySelector('[data-karigari-variant-select]');
      const productRoot = panel.closest('product-info');
      const price = panel.querySelector('[data-karigari-product-price]');
      const comparePrice = panel.querySelector('[data-karigari-compare-price]');
      const stock = panel.querySelector('[data-karigari-stock]');
      const stockLabel = panel.querySelector('[data-karigari-stock-label]');
      const addButton = panel.querySelector('button[name="add"]');
      const addLabel = panel.querySelector('[data-karigari-add-label]');
      const stickyButton = productRoot?.querySelector('[data-karigari-sticky-submit]');
      const stickyBuyNow = productRoot?.querySelector('[data-sticky-buy-now]');
      const quantityInput = panel.querySelector('input[name="quantity"]');
      const stickyQuantity = productRoot?.querySelector('[data-sticky-qty-value]');

      productRoot?.querySelectorAll('[data-karigari-crop]').forEach((button) => {
        button.addEventListener('click', () => {
          const image = productRoot.querySelector('.product__media-list .product__media img');
          if (!image) return;
          const crop = Number(button.dataset.karigariCrop);
          const positions = { 1: '50% 50%', 2: '24% 24%', 3: '76% 30%', 4: '50% 78%' };
          image.style.objectFit = crop === 1 ? 'contain' : 'cover';
          image.style.objectPosition = positions[crop] || positions[1];
          image.style.transform = crop === 1 ? 'scale(1)' : 'scale(1.55)';
          productRoot.querySelectorAll('[data-karigari-crop]').forEach((thumb) => {
            const active = thumb === button;
            thumb.classList.toggle('is-active', active);
            thumb.setAttribute('aria-pressed', String(active));
          });
        });
      });

      productRoot?.querySelectorAll('[data-sticky-qty]').forEach((button) => {
        button.addEventListener('click', () => {
          panel.querySelector(`.quantity__button[name="${button.dataset.stickyQty === 'decrease' ? 'minus' : 'plus'}"]`)?.click();
          if (stickyQuantity && quantityInput) stickyQuantity.textContent = quantityInput.value;
        });
      });
      quantityInput?.addEventListener('change', () => {
        if (stickyQuantity) stickyQuantity.textContent = quantityInput.value;
      });
      stickyBuyNow?.addEventListener('click', () => {
        if (!stickyBuyNow.disabled) panel.querySelector('.shopify-payment-button__button')?.click();
      });

      const syncVariant = () => {
        if (!select) return;
        const option = select.selectedOptions[0];
        if (!option) return;

        const available = option.dataset.available === 'true';
        const nextPrice = option.dataset.price || '';
        const nextComparePrice = option.dataset.comparePrice || '';

        if (price) price.textContent = nextPrice;
        if (stickyButton) {
          stickyButton.disabled = !available;
          if (available) {
            stickyButton.innerHTML = 'Bag · <span data-karigari-sticky-price></span>';
            stickyButton.querySelector('[data-karigari-sticky-price]').textContent = nextPrice;
          } else {
            stickyButton.textContent = 'Sold out';
          }
        }

        if (comparePrice) {
          comparePrice.textContent = nextComparePrice;
          comparePrice.hidden = !nextComparePrice;
        }

        if (stock) {
          stock.classList.toggle('is-sold-out', !available);
        }
        if (stockLabel) stockLabel.textContent = available ? 'In stock' : 'Currently unavailable';

        if (addButton) addButton.disabled = !available;
        if (addLabel) addLabel.textContent = available ? 'Add to cart' : 'Sold out';
        if (stickyBuyNow) stickyBuyNow.disabled = !available;

        const url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        window.history.replaceState({}, '', url);
      };

      select?.addEventListener('change', syncVariant);
      panel.dataset.karigariProductReady = 'true';
    });
  };

  initialiseProductPanel();
  document.addEventListener('shopify:section:load', (event) => initialiseProductPanel(event.target));
})();
